<template>
  <div class="space-y-4" data-test-id="merchant-cases-container">
    <div class="px-4 space-y-4 bg-surface-0 dark:bg-surface-900 rounded-lg">
      <!-- CasesTable for merchant-specific cases -->
      <CasesTable
        ref="casesTableRef"
        class=""
        :showMerchantColumn="false"
        :casesData="merchantCases"
        :pagination="undefined"
        :paginationLoading="false"
        :initialLoading="loading"
      />

      <!-- Empty State -->
      <div
        v-if="!loading && merchantCases.length === 0"
        class="text-center py-12"
      >
        <h3 class="text-lg font-medium text-surface-900 dark:text-surface-0 mb-2">No cases found</h3>
        <p class="text-surface-500 dark:text-surface-400">
          No cases have been created for this supplier yet.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useFCCCaseStore } from '@/stores/fcc'
import { Case } from '@/types/fcc'
import CasesTable from '@/components/fcc/cases/CasesTable.vue'
import { useFrontegg } from '@frontegg/vue'

interface Props {
  merchantId?: number
}

const props = defineProps<Props>()

const caseStore = useFCCCaseStore()
const frontegg = useFrontegg()
const { cases, loading } = storeToRefs(caseStore)

const casesTableRef = ref()

const merchantCases = computed((): Case[] => {
  if (!props.merchantId) return []

  // Filter cases by merchant ID
  return cases.value.filter(
    caseItem => caseItem.MERCHANT_ID === props.merchantId,
  )
})

onMounted(async () => {
  // Fetch cases if we don't have any data
  if (caseStore.cases.length === 0 && !caseStore.loading) {
    try {
      await caseStore.fetchCases(frontegg.authState, undefined, true)
    } catch (error) {
      console.error('Error fetching cases:', error)
    }
  }
})
</script>
